const ngRemove = [() => {
    return {
        scope: { remove: '=ngRemove'},
        /**
         * @param $scope
         * @param $item
         * @param $params {{ ngRemove }}
         */

        link: function ( $scope, $item, $params ) {
            $scope.$watch('remove', (value) => {
                if ( value === true ) {
                    $item[0].remove();
                }
            });
        }
    }
}];
export default ngRemove;
